<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>
<div style="margin-top:20px;page-break-after: always;">
<p v-if="false" align="right">Dnia {{(new Date().toJSON().slice(0, 10).replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1'))}}</p>
<p align="center" class="subheading"><strong>Oświadczenie do umowy o współpracę</strong></p>
<p><strong>Nazwa firmy </strong><span>{{nazwaFirmy}}</span></p>
<p><strong>Adres siedziby firmy </strong><span>{{adresFirmy}}</span><br>
<span class="caption">(ulica, nr domu, kod pocztowy, miejscowość)</span></p>
<p>&nbsp;</p>
<p><strong>Imię i Nazwisko </strong><span>{{imieNazwisko}}</span></p>
<p><strong>PESEL </strong><span>{{pesel}}</span></p>
<p><strong>Seria i Nr dowodu osobistego </strong><span>{{nrDowodu}}</span></p>
<p><strong>Nr telefonu </strong><span>{{nrTelefonu}}</span></p>
<p><strong>E-Mail </strong><span>{{email}}</span></p>

<p><strong>Adres Zamieszkania </strong><span>{{zamieszkany}}</span><br>
<span class="caption">(ulica, nr domu, kod pocztowy, miejscowość)</span></p>

<p><strong>Adres Korespondencyjny </strong><span>{{korespondencyjny}}</span><br>
<span class="caption">(ulica, nr domu, kod pocztowy, miejscowość)</span></p>

<p><strong>Nr rachunku bankowego </strong><span>{{nrRachunku}}</span></p>
<p><br /><br /></p>
</div>
<p align="center" style="margin-top:20px;">
    <strong>UMOWA o WSPÓŁPRACĘ</strong>
</p>
<p>
    Zawarta w Łodzi, pomiędzy:
</p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>
  , z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, o kapitale
  zakładowym w wysokości 1 664 600,00 zł, reprezentowaną przez: 
</p>
<p>
  <strong>{{zamawiajacy}}</strong>, zwaną w dalszej części Umowy <strong>Tutore Poland</strong>
</p>
<p>
  a​ ​firmą
  <br/>
  Nazwa: {{nazwaFirmy}}
  <br/>
  Siedziba: {{adresFirmy}}
  <br/>
  Adres do korespondencji: {{korespondencyjny}}
  <br/>
  NIP: {{NIP}}
  <br/>
  Regon: {{REGON}}
  <br/>
  Tel: {{nrTelefonu}}
  <br/>
  email: {{email}}

  <br/>
  <br/>
  reprezentowaną przez
  <br/>
  Imię i Nazwisko: {{imieNazwisko}}
  <br/>
  Adres zameldowania: {{zameldowany}}
  <br/>
  PESEL: {{pesel}}
  <br/>
  Nr i seria dowodu osobistego: {{nrDowodu}}
  <br/>
  Nr rachunku bankowego: {{nrRachunku}}
  <br/>
  zwanymi w dalszej części umowy <strong>Wykonawcą</strong> o następującej treści:
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p>
<ol>
  <li>
    Tutore Poland zleca prowadzenie, w okresie od dnia zawarcia umowy do 
    {{umowaDo}}, zajęć dydaktycznych związanych z realizacją zajęć 
    dydaktyczno-wychowawczych polegających na prowadzenie zajęć edukacyjnych 
    dla dzieci związanych z nauką gry na instrumentach w kilkuosobowych 
    grupach wg programu, który jest własnością intelektualną Tutore Poland.
  </li>
  <li>
    Strony ustalają, że niniejsza Umowa może zostać rozwiązana z zachowaniem 
    1 miesięcznego okresu wypowiedzenia, ze skutkiem na koniec każdego 
    miesiąca poprzedzającego wypowiedzenie.
  </li>
  <li>
    Łączny wymiar godzin dydaktycznych do wykonania będzie określony każdorazowo przez Tutore Poland z wyprzedzeniem i podsumowany na koniec każdego miesiąca kalendarzowego.
  </li>
  <li>
    Za jednostkę obliczeniową przyjmuje się 45 minut zajęć według ustalonego planu wraz z czynnościami dodatkowymi związanymi z organizacją zajęć oraz wypełnianiem raportów po zajęciach.
  </li>
  <li>
    Celem zapewnienia warunków do wykonania zlecenia Tutore Poland zobowiązuje się do: udostępnienia sal dydaktycznych w salach położonych w szkołach publicznych w lokalizacjach określonych w harmonogramie pracy przedstawianych przez Tutore Poland do akceptacji Wykonawcy.
  </li>
</ol>
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<ol>
  <li>
    Zlecone zajęcia dydaktyczne Wykonawca będzie wykonywał osobiście, przez osobę określoną na początku niniejszej Umowy i nie może powierzyć ich w całości lub części innym osobom bez pisemnej zgody Tutore Poland. Wykonawca zobowiązuje się nie powierzać zleconych w niniejszej Umowie czynności do wykonania osobom trzecim. Naruszenie zakazu, o którym mowa w ust. 1 spowoduje, iż osoba trzecia nie zostanie dopuszczona do wykonania jakichkolwiek czynności i nie otrzyma z tego tytułu żadnego wynagrodzenia.
  </li>
  <li>
    Zlecenie nie będzie wykonywane w siedzibie Tutore Poland. W przypadku wykonywania zlecenia w siedzibie Tutore Poland lub miejscu przez niego wyznaczonym, Wykonawca oświadcza, że zna przepisy i zasady bezpieczeństwa i higieny pracy i zobowiązuje się do ich przestrzegania, a w szczególności do:
  </li>
  <ol type="a">
    <li>
      wykonywania zlecenia w sposób zgodny z przepisami i zasadami bezpieczeństwa i higieny pracy;
    </li>
    <li>
      dbania o należyty stan mienia Zamawiającego oraz o porządek i ład w miejscu wykonywania zlecenia;
    </li>
    <li>
      stosowania występujących w miejscu wykonywania zlecenia, dostępnych środków ochrony zbiorowej, a także używania własnych środków ochrony indywidualnej oraz odzieży i obuwia roboczego, o ile charakter wykonywanej pracy tego wymaga;
    </li>
    <li>
      niezwłocznego zawiadomienia Zamawiającego o zauważonym wypadku albo zagrożeniu życia lub zdrowia ludzkiego oraz ostrzeżenia współpracowników i innych osób znajdujących się w rejonie zagrożenia o grożącym im niebezpieczeństwie,
    </li>
    <li>
      współdziałania z Zamawiającym w czasie ewakuacji, w sytuacji pożaru oraz w przypadku konieczności udzielenia pomocy ofiarom wypadków,
    </li>
    <li>
      prowadzenie dokumentacji zajęć: dziennika zajęć, listy obecności; testów, gier i zabaw, ewaluacji uczniów,  sprawozdania z realizacji zajęć oraz do terminowego wykonywania wszystkich wytycznych organizacyjnych Zamawiającego w terminach przez niego określonych,
    </li>
    <li>
      prowadzenia zajęć odrobieniowych
    </li>
    <li>
      wysyłania umów do biura firmy do 5 dnia każdego miesiąca
    </li>
    <li>
      odpowiadania na kontakt, zalecenia, wytyczne Koordynatora oraz Team Leadera
    </li>
    <li>
      prowadzenie inwentaryzacji
    </li>
    <li>
      prowadzenie e-wizytacji, dbanie o sprzęt udostępniony na czas e-wizytacji, terminowe ich przeprowadzenie, terminowe przesyłanie sprzętu zgodnie z zaleceniami Team Leadera
    </li>
    <li>
      realizowanie celów projektu w zakresie zajęć poprzez:
    </li>
    <ul>
      <li>
        motywowanie ucznia do samodzielnej pracy i przezwyciężania trudności,
      </li>
      <li>
        kształcenie umiejętności niezbędnych do dalszej nauki,
      </li>
      <li>
        kształcenie postawy badawczej,
      </li>
      <li>
        naukę logicznego myślenia,
      </li>
      <li>
        prezentowanie efektów swojej pracy.
      </li>
    </ul>
  </ol>
  <li>
    Wykonawca zobowiązany jest do rzetelnego przygotowania i prowadzenia zajęć  zgodnie z autorskim programem edukacyjnym oraz harmonogramem.
  </li>
  <li>
    Wykonawca zobowiązuje się dochować należytej staranności podczas prowadzenia zajęć.
  </li>
  <li>
    Wykonawca odpowiedzialny jest za jakość i terminowość prowadzonych zajęć.
  </li>
  <li>
    Wykonawca ponosi pełną odpowiedzialność za szkody wyrządzone przez swoje działania lub zaniechania podczas wykonywania przedmiotu umowy.
  </li>
  <li>
    Wykonawca zobowiązany jest do bezzwłocznego informowania Zamawiającego o każdym przypadku uniemożliwiającym mu realizację zajęć zgodnie z harmonogramem.
  </li>
  <li>
    Wykonawca zobowiązany jest do stosowania się do zapisów Ustawy z dnia 29 sierpnia 1997r o ochronie danych osobowych (tj. DZ.U. z 2002r .Nr 101. Poz. 926 ze zmianami).
  </li>
  <li>
    W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z przyczyn leżących po stronie Wykonawcy, zobowiązuje się do niezwłocznego powiadomienia Tutore Poland o zaistniałym fakcie,  nie później niż 3 dni przed planowanymi zajęciami.
  </li>
  <li>
    W przypadku niemożliwości zrealizowania przez Wykonawcę przedmiotu umowy zgodnie z harmonogramem, spowodowanej usprawiedliwioną nieobecnością trwającą w miesiącu nie dłużej niż pięć dni roboczych w sumie lub następujących kolejno po sobie, przy czym przez usprawiedliwioną nieobecność rozumie się wyłącznie nieobecność udokumentowaną zwolnieniem lekarskim lub innym dokumentem urzędowym. Wykonawca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nie odbytym zajęciom, w innym terminie uzgodnionym z Zamawiającym.
  </li>
  <li>
    Strony dopuszczają zmiany dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.
  </li>
  <li>
    W przypadku nie przyjścia na zajęcia określone w harmonogramie zaakceptowanym przez Wykonawcę i nie powiadomienia o tym fakcie Tutore Poland z wyprzedzeniem nie mniejszym niż 1 dzień, Tutore Poland może naliczyć Wykonawcy karę w wysokości 200 zł (słownie złotych dwieście). w Takim przypadku Tutore Poland może rozwiązać Umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. Tutore Poland może ponadto dochodzić odszkodowania od Wykonawcy z tytułu szkód poniesionych w wyniku zaistnienia tego typu sytuacji do wysokości dwukrotnej wartości zaistniałej szkody. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Tutore Poland o niemożliwości przyjścia na zajęcia.
  </li>
</ol>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3 Wynagrodzenie</strong>
</p>
<ol>
<li>
Tytułem wynagrodzenia Wykonawca otrzyma kwotę w wysokości 9 zł netto (słownie złotych: dziewięć) za 1 dziecko zapisane na kurs do Tutore Poland, za 1 godzinę lekcyjną zajęć, trwającą 45 minut. Tutore Poland może podwyższyć wynagrodzenie do 10 zł netto (słownie złotych: dziesięć) za 1 dziecko zapisane na kurs, za 1 godzinę lekcyjną, po spełnieniu poniższych kryteriów:
</li>
<ol type="a">
<li>
prowadzenie zajęć edukacyjnych ściśle wg wytycznych organizacyjnych i merytorycznych określonych przez Tutore Poland, 
</li>
<li>
wypełnianie list obecności zawsze i bez wyjątku tego samego dnia, w którym odbywają się zajęcia,
</li>
<li>
terminowe wypełnianie innych raportów określonych przez Tutore Poland,
</li>
<li>
podpisywanie w imieniu Tutore Poland umów na świadczenie usług edukacyjnych oraz ich dostarczanie w określonym przez Tutore Poland czasie,
</li>
<li>
dostarczanie drogą pocztową lub e-mail-ową dokumentów dotyczących Tutore Poland niezwłocznie, w jak najkrótszym terminie,
</li>
<li>
wypełniania innych wytycznych organizacyjnych na bieżąco przekazywanych przez Tutore Poland w trakcie wykonywania Umowy,
</li>
<li>
brak spóźnień i nie popartych zwolnieniem lekarskim absencji na zajęciach edukacyjnych w trakcie okresu rozliczeniowego,
</li>
<li>
wykonywanie wszystkich wytycznych określonych w § 2 niniejszej Umowy.
</li>
</ol>
<li>
Okresem, w którym dokonywana będzie ocena kryteriów określonych w par. 3.1. jest 1 miesiąc kalendarzowy.
</li>
<li>
Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuję do 15-tego dnia kolejnego miesiąca. Wynagrodzenie jest płatne przelewem na nr konta bankowego Wykonawcy. Warunkiem wypłaty wynagrodzenia jest wykonanie przedmiotu umowy i przesłanie sprawozdania z jego wykonania wg wytycznych Tutore Poland oraz wystawienie i przesłanie faktury przez Wykonawcę.
</li>
</ol>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4 Szkody i ich usuwanie</strong>
</p>
<p>
  W razie niedotrzymania terminu Zleceniobiorca odpowiada za szkody poniesione przez Zleceniodawcę, natomiast przy
  stwierdzeniu błędów i wad przedmiotu umowy – zobowiązany jest do bezpłatnego ich usunięcia.
</p>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5 Okres wypowiedzenia</strong>
</p>
<p>
  Strony mogą rozwiązać Umowę z zachowaniem 1-miesięcznego okresu wypowiedzenia, 
  skutecznego po pisemnym przesłaniu informacji o wypowiedzeniu umowy na koniec 
  następnego miesiąca po złożeniu wypowiedzenia.
  W przypadku rozwiązania Umowy Wykonawca zobowiązuje się do zwrotu materiałów 
  oraz sprzętu udostępnionego na czas trwania umowy przez Zamawiającego w terminie 
  do 14 dni po okresie wypowiedzenia. W przypadku braku zwrotu materiałów i sprzętu 
  w wyznaczonym terminie Zamawiający może nałożyć na Wykonawcę karę finansową 
  o wartości otrzymanych materiałów oraz sprzętu. Dodatkowo Wykonawca może zostać 
  obciążony kosztami przesyłki.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 6 Absencje i powiadamianie o nich</strong>
</p>
<ol>
  <li>
W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z przyczyn leżących po stronie Wykonawcy, zobowiązuje się do niezwłocznego powiadomienia Tutore Poland o zaistniałym fakcie,  nie później niż 3 dni przed planowanymi zajęciami. W takim przypadku Tutore Poland może wyznaczyć osobę, która zastąpi Wykonawcę w wykonaniu zlecenia opisanego w niniejszej umowie.
  </li>
  <li>
W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Wykonawca może nie zachować 3 dniowego okresu powiadomienia o niemożności wykonywania zlecenia. Wykonawca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia, powiadomić o takiej sytuacji Tutore Poland..
  </li>
  <li>
W przypadku niemożliwości zrealizowania przez Wykonawcę przedmiotu umowy zgodnie z harmonogramem, spowodowanej usprawiedliwioną nieobecnością trwającą w miesiącu nie dłużej niż pięć dni roboczych w sumie lub następujących kolejno po sobie, przy czym przez usprawiedliwioną nieobecność rozumie się wyłącznie nieobecność udokumentowaną zwolnieniem lekarskim lub innym dokumentem urzędowym. Wykonawca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nie odbytym zajęciom, w innym terminie uzgodnionym z Zamawiającym.
  </li>
  <li>
Strony dopuszczają zmiany dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.
  </li>
  <li>
W przypadku nie przyjścia na zajęcia określone w harmonogramie zaakceptowanym przez Wykonawcę i nie powiadomienia o tym fakcie Tutore Poland z wyprzedzeniem nie mniejszym niż 1 dzień, Tutore Poland może naliczyć Wykonawcy karę w wysokości 200 zł (słownie złotych dwieście). w Takim przypadku Tutore Poland może rozwiązać Umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. Tutore Poland może ponadto dochodzić odszkodowania od Wykonawcy z tytułu szkód poniesionych w wyniku zaistnienia tego typu sytuacji do wysokości dwukrotności wartości zaistniałej szkody. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Tutore Poland o niemożliwości przyjścia na zajęcia.
  </li>
</ol>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7 Zakaz konkurencji</strong>
</p>
<ol>
<li>
Za działalność  konkurencyjną  w rozumieniu niniejszego paragrafu Strony uznają: prowadzenie zajęć edukacyjnych z gry na instrumentach muzycznych w kilkuosobowych grupach na terenie publicznych i niepublicznych szkół podstawowych,  gimnazjów i szkół  średnich na terenie Polski. Inne formy prowadzenia zajęć z gry na instrumentach muzycznych nie podlegają zakazowi konkurencji. 
</li>
<li>
Zakaz konkurencji obowiązuje również w przypadku oferowania wszelkich usług edukacyjnych związanych z nauczaniem gry na instrumentach wszystkim byłym, którzy zakończyli współpracę ze Szkołą współpracę do 12 miesięcy po zakończeniu Umowy, lub obecnym Klientom Szkoły.
</li>
<li>
Wykonawca zobowiązuje się w czasie trwania współpracy opisanej niniejszą umową  nie prowadzić  działalności konkurencyjnej względem działalności Zamawiającego wg definicji przedstawionej w punkcie 7.1, ze szczególnym uwzględnieniem przypadków:
</li>
<ol type="a">
  <li>
    świadczenia pracy na rzecz podmiotu prowadzącego działalność  konkurencyjną względem Zamawiającego, zdefiniowaną w punkcie 7.1;
  </li>
  <li>
    świadczenia usług w oparciu o jakąkolwiek umowę prawa cywilnego na rzecz podmiotu prowadzącego działalność konkurencyjną względem Zamawiającego, zdefiniowaną w punkcie 7.1;
  </li>
  <li>
    prowadzenie przedsiębiorstwa prowadzącego działalność  konkurencyjną  względem Zamawiającego,  także za pośrednictwem osoby trzeciej;
  </li>
  <li>
    bycia wspólnikiem spółki prowadzącej działalność  konkurencyjną  względem Zamawiającego;
  </li>
  <li>
    zasiadanie w organach podmiotów prowadzących działalność  konkurencyjną  wobec Zamawiającego.
  </li>
</ol>
<li>
Strony postanawiają, że zakaz prowadzenia działalności konkurencyjnej na zasadach opisanych w niniejszym paragrafie rozciągał się będzie również na okres 12 (dwunastu) miesięcy od dnia zakończenia lub rozwiązania niniejszej umowy.
</li>
<li>
W przypadku naruszenia zobowiązań  wynikających z niniejszego paragrafu Wykonawca zapłaci na żądanie Zamawiającego karę umowną w kwocie stanowiącej równowartość 20 000 zł (słownie złotych: dwadzieścia tysięcy).
</li>
<li>
Zastrzeżenie wyżej wymienionej kary umownej nie wyklucza dochodzenia odszkodowania przenoszącego jej wysokość.
</li>
</ol>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8 Forma umowy</strong>
</p>
<ol>
  <li> 
    Zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.
  </li>
  <li>
    W sprawach nieuregulowanych niniejszą umową mają zastosowanie przepisy Kodeksu Cywilnego.
  </li>
</ol>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 9 Właściwy Sąd</strong>
</p>
<p>
  Do rozpoznania sporów wynikających z niniejszej umowy właściwy będzie Sąd Powszechny w Łodzi.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 10 Ilość umów</strong>
</p>
<p>
  Umowę sporządzono w dwóch jednobrzmiących egzemplarzach, po jednej dla każdej ze stron.
</p>
<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        {{zamawiajacy}}<br>
        <span style="margin-left: 15%;">(Zleceniodawca)</span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 15%;">(Wykonawca)</span>
    </div>
</div>
<div style="margin-top:40px;page-break-before: always;">
<p align="center" class="subheading"><strong>Informacja o ochronie danych osobowych </strong></p>
<p>&nbsp;</p>
<p><span>
  Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 
  z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku 
  z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych 
  oraz uchylenia dyrektywy 95/46/WE og&oacute;lne rozporządzenie o ochronie danych, 
  (&bdquo;Rozporządzenie&rdquo;) informujemy, że Administratorem Danych Osobowych jest: 
</span></p>
<p>&nbsp;</p>
<p><em>
  <span>
    Tutore Poland Sp. z o.o. z siedzibą w Łodzi przy 
    ul. Piotrkowska 157A, 90-440 Ł&oacute;dź, 
    wpisana do rejestru przedsiębiorc&oacute;w pod numerem KRS: 0000670834, 
    sąd rejestrowy dla Łodzi Śr&oacute;dmieścia, XX Wydział Krajowego Rejestru Sądowego, 
    NIP: 7272812193.
  </span>
</em></p>
<p>
  <span>
    Kontakt z Administratorem Danych Osobowych możesz uzyskać pisemnie, 
    kierując korespondencję na powyższy adres lub elektronicznie, korzystając z adresu e-mail: 
  </span>
  <a href="mailto:kadry@szkolam.pl"><span>kadry@szkolamm.pl</span></a>
</p>
<p>&nbsp;</p>
<p><span>
  Dane osobowe są przetwarzane w celu zawarcia i realizacji zawartej umowy, 
  tj. na podstawie art. 6 ust. 1 lit. b &nbsp;Rozporządzenia. 
  Podanie danych jest dobrowolne, jednak konieczne w celu zawarcia i wykonania Umowy. 
  W związku z realizacją usług dane osobowe zostaną przekazane podmiotom zewnętrznym, 
  w tym w szczeg&oacute;lności dostawcom system&oacute;w i usług informatycznych, 
  bankom i operatorom płatności, podmiotom świadczącym usługi księgowe,prawne, audytowe, 
  konsultingowe, kurierom, oraz podmiotom powiązanym z Administratorem, 
  kt&oacute;rzy zajmują się realizacją zam&oacute;wień. Dane osobowe będą przechowywane 
  przez okres trwania umowy, a po jej zakończeniu przez czas wynikający z obowiązujących 
  przepis&oacute;w prawa lub do czasu przedawnienia wzajemnych roszczeń. Każda osoba, 
  kt&oacute;rej dane dotyczą ma prawo dostępu do swoich danych osobowych, żądania 
  ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo wniesienia sprzeciwu 
  wobec przetwarzania danych oraz prawo do przenoszenia danych. 
  W celu realizacji powyższych uprawnień należy skontaktować się 
  z Administratorem Danych Osobowych, korzystając z danych teleadresowych, 
  wskazanych powyżej. Osoba, kt&oacute;rej dane dotyczą ma także prawo wniesienia skargi 
  do organu nadzorczego, gdy uzna, iż przetwarzanie danych osobowych narusza przepisy prawa.
  </span></p>
</div>

<div style="margin-top: 40px; page-break-before: always;">

<p align="center"><strong>Umowa powierzenia przetwarzania danych osobowych</strong></p>
<p>&nbsp;</p>
<p><span>(zwana dalej &bdquo;Umową&rdquo;) zawarta pomiędzy: </span></p>
<p><strong>Tutore Poland sp&oacute;łka z ograniczoną odpowiedzialnością </strong>
<span>
  z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Ł&oacute;dź, 
  wpisaną do rejestru przedsiębiorc&oacute;w pod numerem KRS: 0000670834, 
  sąd rejestrowy: Sąd Rejonowy dla Łodzi-Śr&oacute;dmieścia w Łodzi, XX Wydział Gospodarczy KRS, 
  NIP: 7272812193, REGON: 366891567,
</span>
</p>
<p><span>reprezentowaną przez: </span>
<strong>{{zamawiajacy}}</strong><span>, zwaną/zwanego </span>
<span>w dalszej części umowy </span><strong>&bdquo;Administratorem&rdquo;</strong></p>
<p><span>oraz</span></p>
<p>Nazwa: {{nazwaFirmy}}
<br/>
Siedziba: {{adresFirmy}}
<br/>
Adres do korespondencji: {{korespondencyjny}}
<br/>
NIP: {{NIP}}
<br/>
Regon: {{REGON}}
<br/>
Tel: {{nrTelefonu}}
<br/>
email: {{email}}
</p>
<p><span>Imię i Nazwisko: {{imieNazwisko}}</span><br />
<span>Adres Zamieszkania: {{zamieszkany}}</span><br />
<span>PESEL: {{pesel}}</span></p>
<p>
  <span>zwanym/zwaną w dalszej części umowy </span>
  <strong>&bdquo;Podmiotem przetwarzającym&rdquo;</strong>
</p>
<p>&nbsp;</p>
<p><strong>Preambuła</strong></p>
<p><span>Zważywszy iż:</span></p>
<ul>
<li><span>
  Strony łączy umowa z dnia {{(new Date().toJSON().slice(0, 10).replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1'))}} 
  o świadczenie usług polegających na przygotowaniu bazy danych os&oacute;b zainteresowanych usługami sp&oacute;łki 
  (zwana dalej: &bdquo;Umową podstawową&rdquo;);
</span></li>
<li><span>
  w związku z zawarciem i wykonywaniem Umowy konieczne jest powierzenie Podmiotowi przetwarzającemu 
  przez Administratora danych osobowych w trybie art.&nbsp;28 rozporządzenia Parlamentu Europejskiego 
  i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych 
  w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych 
  oraz uchylenia dyrektywy 95/46/WE (og&oacute;lnego rozporządzenia o ochronie danych) 
  (Dz.U.UE.L.2016.119.1) &ndash; zwanego dalej: &bdquo;Rozporządzeniem&rdquo;,
  </span></li>
</ul>
<p style="margin-top: 20px;"><span>Strony postanowiły zawrzeć umowę o następującej treści:</span></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§1 Powierzenie przetwarzania danych osobowych</strong>
</p>
<ol>
<li><span>Mając na uwadze treść art. art. 28 Rozporządzenia, Administrator danych powierza Podmiotowi przetwarzającemu dane osobowe do przetwarzania, na zasadach &nbsp;i w celu określonym w niniejszej umowie.</span></li>
<li><span>Zawarcie niniejszej umowy powierzenia stanowi udokumentowane polecenie Administratora do przetwarzania danych przez Podmiot przetwarzający.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się przetwarzać powierzone mu dane osobowe zgodnie z niniejszą umową, Rozporządzeniem oraz z innymi przepisami prawa powszechnie obowiązującego, kt&oacute;re chronią prawa os&oacute;b, kt&oacute;rych dane dotyczą.</span></li>
<li><span>Podmiot przetwarzający oświadcza, iż stosuje techniczne i organizacyjne środki zapewniające bezpieczeństwo danych i ochronę praw os&oacute;b, kt&oacute;rych one dotyczą oraz &nbsp;spełniające wymogi Rozporządzenia. </span></li>
</ol>
<p>&nbsp;<br><br></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§2 Zakres i cel przetwarzania danych</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający będzie przetwarzał powierzone na podstawie niniejszej umowy następujące dane:</span></li>
</ol>
<p>&nbsp;</p>
<table style="border: 1px solid; text-align: left;">
<tbody>
<tr>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Kategorie os&oacute;b, kt&oacute;rych dotyczy przetwarzanie</span></p>
</td>
<td>
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Rodzaj danych osobowych</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Czy powierzone dane osobowe obejmują szczeg&oacute;lne kategorie danych?</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Zakres przetwarzania</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Forma przetwarzania</span></p>
</td>
</tr>
<tr>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>dane osobowe dzieci i ich rodzic&oacute;w/opiekun&oacute;w prawnych </span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Imię i nazwisko dziecka, nr tel., PESEL, adres zamieszkania, e-mail, plan zajęć dziecka</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Nie</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>organizowanie, utrwalanie, porządkowanie.</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Elektroniczna i papierowa</span></p>
</td>
</tr>
</tbody>
</table>
<p><br /><br /></p>
<ol>
<li><span>Powierzone przez Administratora dane osobowe będą przetwarzane przez Podmiot przetwarzający wyłącznie w celu wykonania Umowy podstawowej. </span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§3 Obowiązki podmiotu przetwarzającego</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający zobowiązuje się, przy przetwarzaniu powierzonych danych osobowych, do ich zabezpieczenia poprzez stosowanie odpowiednich środk&oacute;w technicznych i organizacyjnych zapewniających adekwatny stopień bezpieczeństwa odpowiadający ryzyku związanym z przetwarzaniem danych osobowych, o kt&oacute;rych mowa w art. 32 Rozporządzenia. Podmiot przetwarzający zobowiązuje się do regularnej weryfikacji i aktualizacji stosowanych przez niego środk&oacute;w technicznych i organizacyjnych tak, aby zapewnić powierzonym danym osobowym adekwatny stopień ochrony. Podmiot przetwarzający, na każde żądanie Administratora danych, przekaże informacje o stosowanych przez niego środkach organizacyjnych i technicznych związanych z przetwarzaniem danych osobowych.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się dołożyć należytej staranności przy przetwarzaniu powierzonych danych osobowych.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się do nadania upoważnień do przetwarzania danych osobowych wszystkim osobom, kt&oacute;re będą przetwarzały powierzone dane w celu realizacji niniejszej umowy. </span></li>
<li><span>Podmiot przetwarzający zobowiązuje się, że osoby, kt&oacute;re będą przetwarzały w jego imieniu dane osobowe powierzone na podstawie niniejszej umowy zostaną dopuszczone do przetwarzania jedynie po odbyciu szkoleń z zakresu ochrony danych osobowych (w szczeg&oacute;lności z ochrony danych osobowych i odpowiedzialności za ochronę tych danych przed niepowołanym dostępem, nieuzasadnioną modyfikacją, zniszczeniem, nielegalnym ujawnieniem lub pozyskaniem danych osobowych). Podmiot przetwarzający oświadcza, że dostęp do danych osobowych będą miały jedynie osoby, dla kt&oacute;rych dostęp ten jest niezbędny do wykonania usług określonych w Umowie gł&oacute;wnej.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się zapewnić zachowanie powierzonych danych w tajemnicy, o kt&oacute;rej mowa w art. 28 ust 3 pkt b Rozporządzenia. W tym celu Podmiot przetwarzający &nbsp;zobowiązuje do zachowania przetwarzanych danych w tajemnicy osoby, kt&oacute;re upoważnia do przetwarzania danych osobowych w celu realizacji niniejszej umowy, zar&oacute;wno w trakcie zatrudnienia ich w Podmiocie przetwarzającym, jak i po jego ustaniu.</span></li>
<li><span>Podmiot przetwarzający po zakończeniu świadczenia usług związanych </span><span><br /></span><span>z przetwarzaniem usuwa wszelkie dane osobowe powierzone na podstawie niniejszej umowy oraz wszelkie ich istniejące kopie, chyba że prawo Unii lub prawo państwa członkowskiego nakazują przechowywanie danych osobowych.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się wsp&oacute;łpracować z Administratorem w wywiązywaniu się z obowiązku odpowiadania na żądania osoby, kt&oacute;rej dane dotyczą oraz wywiązywania się z obowiązk&oacute;w określonych w art. 32-36 Rozporządzenia. W tym celu Podmiot przetwarzający zobowiązuje się w szczeg&oacute;lności udzielać Administratorowi stosowne informacje lub przekazywać niezbędne dokumenty związane z żądaniem osoby fizycznej i przetworzonymi przez niego danymi osobowymi, nie p&oacute;źniej niż w terminie 7 dni od dnia skierowania stosownego żądania przez Administratora danych</span></li>
<li><span>Podmiot przetwarzający po stwierdzeniu naruszenia ochrony danych osobowych bez zbędnej zwłoki, jednak nie p&oacute;źniej niż w ciągu 24 godzin od chwili powzięcia wiedzy o naruszeniu, zgłasza je Administratorowi. Zgłoszenie będzie zawierać co najmniej opis okoliczności zdarzenia stanowiącego naruszenie ochrony danych osobowych oraz jego ustalonych lub podejrzewanych przyczyn; opis charakteru naruszenia ochrony danych osobowych, w tym w miarę możliwości wskazanie kategorii i przybliżonej liczby os&oacute;b, kt&oacute;rych dane osobowe dotyczą; opis możliwych konsekwencji naruszenia ochrony danych osobowych; opis zastosowanych przez Podmiot przetwarzający środk&oacute;w zaradczych w celu zminimalizowania ewentualnych negatywnych skutk&oacute;w naruszenia ochrony danych osobowych.</span></li>
<li><span>W przypadku stwierdzenia jakiejkolwiek sytuacji stanowiącej naruszenie ochrony danych osobowych lub grożącej takim naruszeniem Podmiot przetwarzający zobowiązany jest:</span></li>

<ol>
<li><span>niezwłocznie, lecz nie p&oacute;źniej niż w ciągu 24 godzin od stwierdzenia takiej sytuacji, poinformować o tym Administratora,</span></li>
<li><span>podjąć niezwłocznie wszelkie czynności mające na celu usunięcie naruszenia lub zagrożenia i zabezpieczenie danych osobowych w spos&oacute;b należyty przed dalszymi naruszeniami,</span></li>
<li><span>zebrać wszystkie możliwe dane i dokumenty, kt&oacute;re mogą pom&oacute;c w ustaleniu okoliczności naruszenia i przeciwdziałaniu podobnym sytuacjom w przyszłości,</span></li>
<li><span>udzielać Administratorowi wszelkich wyjaśnień.</span></li>
</ol>
<li><span>Podmiot przetwarzający oświadcza, że nie powołał Inspektora Ochrony Danych.</span></li>
<li><span>Podmiot przetwarzający oświadcza, że powierzone mu do przetwarzania Dane osobowe przetwarzane będą wyłącznie na terytorium Unii Europejskiej lub Europejskiego Obszaru Gospodarczego.**</span></li>

</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§4 Prawo kontroli</strong>
</p>
<ol>
<li><span>Administrator danych zgodnie z art. 28 ust. 3 pkt h) Rozporządzenia ma prawo kontroli &nbsp;&nbsp;&nbsp;i weryfikacji czy środki zastosowane przez Podmiot przetwarzający przy przetwarzaniu i zabezpieczeniu powierzonych danych osobowych spełniają postanowienia niniejszej umowy i Rozporządzenia. </span></li>
<li><span>Administrator danych realizować będzie prawo kontroli w godzinach pracy Podmiotu przetwarzającego i z minimum 3 dniowym jego uprzedzeniem.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się do usunięcia uchybień stwierdzonych podczas kontroli w terminie wskazanym przez Administratora danych nie dłuższym niż 7 dni.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się wsp&oacute;łpracować z Administratorem w zakresie prowadzonej kontroli, w tym w szczeg&oacute;lności zobowiązuje się:</span></li>
<ol>
<li><span>udostępnić Administratorowi wszelkie informacje i dokumenty niezbędne do przeprowadzenia kontroli, </span></li>
<li><span>dopuścić Administratora do obszaru przetwarzania danych osobowych oraz system&oacute;w informatycznych związanych z przetwarzaniem danych osobowych,</span></li>
<li><span>zapewnić Administratorowi możliwość przeprowadzenia rozm&oacute;w z pracownikami i wsp&oacute;łpracownikami Podmiotu przetwarzającego.</span></li>
</ol>
<li><span>Administrator danych jest uprawniony do wydawania Podmiotowi przetwarzającemu wiążących poleceń odnośnie sposobu wykonania niniejszej umowy.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§5 Dalsze powierzenie danych do przetwarzania</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający może powierzyć dane osobowe objęte niniejszą umową do dalszego przetwarzania podwykonawcom jedynie w celu wykonania umowy po uzyskaniu uprzedniej pisemnej zgody Administratora danych. &nbsp;</span></li>
<li><span>Przekazanie powierzonych danych do państwa trzeciego może nastąpić jedynie na pisemne polecenie Administratora danych chyba, że obowiązek taki nakłada na Podmiot przetwarzający prawo Unii lub prawo państwa członkowskiego, kt&oacute;remu podlega Podmiot przetwarzający. W takim przypadku przed rozpoczęciem przetwarzania Podmiot przetwarzający informuje Administratora danych o tym obowiązku prawnym, o ile prawo to nie zabrania udzielania takiej informacji z uwagi na ważny interes publiczny.</span></li>
<li><span>Podwykonawca, o kt&oacute;rym mowa w &sect; 5 ust. 1 winien spełniać te same gwarancje &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;i obowiązki jakie zostały nałożone na Podmiot przetwarzający w niniejszej umowie. </span></li>
<li><span>Podmiot przetwarzający ponosi pełną odpowiedzialność wobec Administratora za niewywiązanie się ze spoczywających na podwykonawcy obowiązk&oacute;w w zakresie ochrony danych osobowych.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§6 Odpowiedzialność Podmiotu przetwarzającego</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający jest odpowiedzialny za szkody wyrządzone Administratorowi, osobie fizycznej, kt&oacute;rej dane osobowe dotyczą lub innym osobom trzecim w związku z niewykonaniem lub nienależytym wykonaniem Umowy powierzenia, polegającym w szczeg&oacute;lności na działaniu niezgodnym z treścią Umowy powierzenia &nbsp;lub Rozporządzenia.</span></li>
<li><span>Podmiot przetwarzający jest odpowiedzialny za udostępnienie lub wykorzystanie danych osobowych niezgodnie z treścią umowy, a w szczeg&oacute;lności za udostępnienie powierzonych do przetwarzania danych osobowych osobom nieupoważnionym. </span></li>
<li><span>Podmiot przetwarzający odpowiada za działania i zaniechania os&oacute;b, przy pomocy kt&oacute;rych będzie przetwarzał powierzone dane osobowe, jak za działania lub zaniechania własne.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się do niezwłocznego poinformowania Administratora danych o jakimkolwiek postępowaniu, w szczeg&oacute;lności administracyjnym lub sądowym, dotyczącym przetwarzania przez Podmiot przetwarzający danych osobowych określonych w umowie, o jakiejkolwiek decyzji administracyjnej lub orzeczeniu dotyczącym przetwarzania tych danych, skierowanych do Podmiotu przetwarzającego, a także o wszelkich planowanych, &nbsp;o ile są wiadome, lub realizowanych kontrolach i inspekcjach dotyczących przetwarzania w Podmiocie przetwarzającym tych danych osobowych. Niniejszy ustęp dotyczy wyłącznie danych osobowych powierzonych przez Administratora danych. </span></li>
<li><span>W przypadku nałożenia na Administratora prawomocnej kary za niezgodne z prawem przetwarzanie danych osobowych przez Podmiot przetwarzający lub podwykonawcę, o kt&oacute;rym mowa w &sect; 5 ust. 1 Umowy, Podmiot przetwarzający zapłaci na rzecz Administratora karę umowną w wysokości ciężaru finansowego nałożonego na Administratora.</span></li>
<li><span>W przypadku, gdy w związku z niezgodnym z niniejszą umową i przepisami Rozporządzania przetwarzaniem danych osobowych powierzonych Podmiotowi przetwarzającemu, z przyczyn leżących po stronie Podmiotu przetwarzającego (wina), Administrator poniesie jakiekolwiek koszty, w szczeg&oacute;lności związane z wypłatą zadośćuczynienia lub koszty obsługi prawnej, Podmiot przetwarzający zobowiązany będzie pokrycia tych koszt&oacute;w w pełnej wysokości, a w przypadku wytoczonego postępowania sądowego - do udzielenia Administratorowi wszelkiego wsparcia w takim postępowaniu, a także do przejęcia odpowiedzialności w przypadku przyznania osobie fizycznej odszkodowania w takim postępowaniu, w wysokości odpowiadającej r&oacute;wnowartości przyznanego odszkodowania lub koszt&oacute;w zadośćuczynienia oraz wszelkich koszt&oacute;w niezbędnych do obrony przed zgłaszanymi roszczeniami a poniesionych przez Administratora w takim postępowaniu.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§7 Czas obowiązywania umowy</strong>
</p>
<ol>
<li><span>Niniejsza umowa obowiązuje od dnia jej zawarcia przez cały &nbsp;czas obowiązywania Umowy podstawowej. </span></li>
<li><span>Podmiot przetwarzający zaprzestanie przetwarzania danych osobowych wraz z wygaśnięciem Umowy podstawowej, jak r&oacute;wnież na każde żądanie Administratora.</span></li>
<li><span>Każda ze stron może wypowiedzieć niniejszą umowę z zachowaniem miesięcznego okresu wypowiedzenia.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§8 Rozwiązanie umowy</strong>
</p>
<ol>
<li><span>Niniejsza umowa została zawarta na czas obowiązywania Umowy podstawowej, przy czym rozwiązanie, wypowiedzenie lub wygaśnięcie Umowy podstawowej powoduje jednoczesne odpowiednio rozwiązanie, wypowiedzenie lub wygaśnięcie niniejszej umowy bez konieczności składania przez Strony dodatkowych oświadczeń w tym zakresie, chyba że Strony postanowią inaczej, z zastrzeżeniem kolejnych ustęp&oacute;w.</span></li>
<li><span>Administrator danych może rozwiązać niniejszą umowę ze skutkiem natychmiastowym, gdy Podmiot przetwarzający:</span></li>

<ol>
<li><span>pomimo zobowiązania go do usunięcia uchybień stwierdzonych podczas kontroli nie usunie ich w wyznaczonym terminie;</span></li>
<li><span>przetwarza dane osobowe w spos&oacute;b niezgodny z umową lub Rozporządzeniem;</span></li>
<li><span>powierzył przetwarzanie danych osobowych innemu podmiotowi bez zgody Administratora danych;</span></li>
</ol>

<li><span>Rozwiązanie umowy w trybie opisanym w ust. 2 powyżej następuje poprzez złożenie przez Administratora pisemnego oświadczenia Podmiotowi przetwarzającemu.</span></li>
<li><span>Strony zgodnie postanawiają, że rozwiązanie umowy powierzenia w spos&oacute;b określony w &nbsp;&nbsp;ust. 2 powyżej powoduje jednoczesne rozwiązanie Umowy podstawowej z winy Podmiotu przetwarzającego bez konieczności składania dodatkowych oświadczeń, chyba że co innego wynika z oświadczenia Administratora, o kt&oacute;rym mowa w ust. 3 powyżej.</span></li>

</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§9 Wzajemna komunikacja</strong>
</p>
<ol>
<li><span>W celu zapewnienia wzajemnej komunikacji w zakresie realizacji przedmiotu niniejszej umowy Strony wskazują poniżej do kontaktu następujące adresy poczty elektronicznej:</span></li>

<ol>
<li><span>po stronie Administratora: kadry@szkolamm.pl</span></li>
<li><span>po stronie Podmiotu przetwarzającego: {{email}}</span></li>
</ol>

<li><span>Zmiana adres&oacute;w poczty elektronicznej, o kt&oacute;rych mowa w ust. 1 nie wymaga zmiany niniejszej umowy i następuje poprzez wzajemne zawiadomienie przez Strony.</span></li>
<li><span>Strony zgodnie oświadczają, że osoby wskazane w pkt. 1 zostały poinformowane, iż administratorem ich danych osobowych jest odpowiednio Administrator lub Podmiot przetwarzający; dane osobowe będą przechowywane przez czas trwania umowy, a także po jej zakończeniu w celu wykonania obowiązk&oacute;w prawnych oraz dochodzenia wzajemnych roszczeń do czasu ich przedawnienia; odbiorcami danych są podmioty świadczące usługi archiwizacji i niszczenia dokument&oacute;w, firmy hostingowe oraz informatyczne, w tym podmioty obsługujące pocztę e-mail; mają prawo dostępu do swoich danych osobowych, żądania ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo wniesienia sprzeciwu wobec przetwarzania danych oraz prawo do przenoszenia danych, a także prawo wniesienia skargi do organu nadzorczego w przypadku przetwarzania danych osobowych naruszającego przepisy prawa.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§10 Zasady zachowania poufności</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający zobowiązuje się do zachowania w tajemnicy wszelkich informacji, danych, materiał&oacute;w, dokument&oacute;w i danych osobowych otrzymanych od Administratora danych i od wsp&oacute;łpracujących z nim os&oacute;b oraz danych uzyskanych w jakikolwiek inny spos&oacute;b, zamierzony czy przypadkowy w formie ustnej, pisemnej lub elektronicznej (&bdquo;dane poufne&rdquo;).</span></li>
<li><span>Podmiot przetwarzający oświadcza, że w związku ze zobowiązaniem do zachowania w tajemnicy danych poufnych nie będą one wykorzystywane, ujawniane ani udostępniane bez pisemnej zgody Administratora danych w innym celu niż wykonanie Umowy, chyba że konieczność ujawnienia posiadanych informacji wynika z obowiązujących przepis&oacute;w prawa lub Umowy.</span></li>
<li><span>Obowiązek zachowania w tajemnicy danych poufnych obowiązuje w czasie trwania niniejszej umowy oraz przez okres 5 lat od jej rozwiązania (bez względu na przyczynę).</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§11 Postanowienia końcowe</strong>
</p>
<ol>
<li><span>Sądem właściwym dla rozpatrzenia spor&oacute;w wynikających z niniejszej umowy będzie sąd właściwy dla Administratora danych. </span></li>
<li><span>W sprawach nieuregulowanych zastosowanie będą miały przepisy Kodeksu cywilnego oraz Rozporządzenia.</span></li>
<li><span>Umowa została sporządzona w dw&oacute;ch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</span></li>
</ol>
<p><br /><br /><br /></p>


<div class="cointainer" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    {{zamawiajacy}}<br>
    <span class="caption">(Administrator danych)</span>
  </div>
  <div class="right-cointainer">
    {{imieNazwisko}}<br>
    <span class="caption">(Podmiot przetwarzający)</span>
  </div>
</div>

<p><br /><br /></p>
<p><span>** jeżeli podmiot przetwarzający zamierza &nbsp;przekazywać dane osobowe do państwa trzeciego, należy wskazać tę okoliczność w umowie i podać podstawę prawną przekazania</span></p>

</div>


</td></tr>
</tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'UmowaWspolpraca',
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zameldowany: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      nazwaFirmy: '',
      adresFirmy: '',
      NIP: '',
      REGON: '',
      umowaDo: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaWspolpraca.vue